import { instructorsData, instructorData } from 'store/saga/entities/bound';

export const selectIsInstructorLoading = (state, instructorId) => instructorData.loading(state, instructorId);

export const selectInstructor = (state, instructorId) =>
  instructorData.loaded(state, instructorId) && instructorId ? instructorData.data(state, instructorId) : {};

export const selectInstructors = (state, venueId) =>
  instructorsData.loaded(state, venueId) ? instructorsData.data(state, venueId) : [];

export const selectSelectedInstructorId = state => state.instructors.selectedInstructorId;

export const selectShouldScrollToItem = state => state.instructors.shouldScrollToItem;

export const selectInstructorsIsLoading = (state, venueId) => instructorsData.loading(state, venueId);
export const selectInstructorsIsLoaded = (state, venueId) => instructorsData.loaded(state, venueId);
